import {
  ADD_CREDIT_TO_BOOKMARK_ACTION,
  REMOVE_CREDIT_FROM_BOOKMARK_ACTION,
  FETCH_CREDIT_BOOKMARKS,
} from "./creditBookmarkAction";

import {
  setLocalStorageCreditBookmarks,
  getLocalStorageCreditBookmarks,
} from "utils/localStorage";

const initialState = {
  creditBookmarks: [],
};

const creditBookmarkReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CREDIT_TO_BOOKMARK_ACTION: {
      const { sourceInstitutionID, creditItemID, creditType, timestamp } =
        action;
      const currentCreditBookmarks = [
        ...state.creditBookmarks,
        { sourceInstitutionID, creditItemID, creditType, timestamp },
      ];

      setLocalStorageCreditBookmarks(currentCreditBookmarks);
      return {
        creditBookmarks: currentCreditBookmarks,
      };
    }

    case REMOVE_CREDIT_FROM_BOOKMARK_ACTION: {
      const { creditItemID } = action;
      const currentCreditBookmarks = state.creditBookmarks.filter(
        (creditItem) => creditItem.creditItemID !== creditItemID,
      );

      setLocalStorageCreditBookmarks(currentCreditBookmarks);
      return {
        creditBookmarks: currentCreditBookmarks,
      };
    }

    case FETCH_CREDIT_BOOKMARKS: {
      const creditBookmarks = getLocalStorageCreditBookmarks();
      return {
        creditBookmarks,
      };
    }

    default: {
      return state;
    }
  }
};

export default creditBookmarkReducer;
